const MODULE_NAME = 'addFocus';
export default angular.module(MODULE_NAME, [])
	.directive('addFocus', function ($timeout, $parse) {
		'ngInject';
		return {
			link: function (scope, element, attrs) {
				var model = $parse(attrs.addFocus);
				scope.$watch(model, function (value) {
					if (value === true) {
						$timeout(function () {
							element[0].focus();
						});
					}
				});
			}
		};
	}).name;



// WEBPACK FOOTER //
// ./source/common/addfocus/addfocus.js